import React, { useState, useEffect, useRef } from 'react';
import { realtimeDb, auth } from '../firebaseConfig';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { ref, onValue, push, set, off } from 'firebase/database';
import { Modal, Button, Input, List, Divider, Badge, Upload } from 'antd';
import { UploadOutlined, CloseCircleOutlined, FileOutlined, CloseOutlined } from '@ant-design/icons';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import './Pomoc.css';
import { SmileOutlined, AudioOutlined, SendOutlined } from '@ant-design/icons';

const Pomoc = () => {
    const [chats, setChats] = useState([]);
    const [selectedChat, setSelectedChat] = useState(null);
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState('');
    const [user, setUser] = useState(null);
    const [userInfo, setUserInfo] = useState({});
    const [chatName, setChatName] = useState('');
    const [newChatFirstMessage, setNewChatFirstMessage] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isCreateChatModalVisible, setIsCreateChatModalVisible] = useState(false);
    const [unreadCounts, setUnreadCounts] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewImageUrl, setPreviewImageUrl] = useState(null);
    const [isImageModalVisible, setIsImageModalVisible] = useState(false);
    const [modalImageUrl, setModalImageUrl] = useState(null);

    const messagesEndRef = useRef(null);
    const firestore = getFirestore();
    const storage = getStorage();

    // Устанавливаем атрибуты для предотвращения перевода при монтировании компонента
    useEffect(() => {
        document.documentElement.setAttribute('translate', 'no');
        document.documentElement.setAttribute('lang', 'pl');
        document.documentElement.classList.add('notranslate');
        
        if (!document.querySelector('meta[name="google"][content="notranslate"]')) {
            const googleMeta = document.createElement('meta');
            googleMeta.name = 'google';
            googleMeta.content = 'notranslate';
            document.head.appendChild(googleMeta);
        }
        
        if (!document.querySelector('meta[name="robots"][content="notranslate"]')) {
            const robotsMeta = document.createElement('meta');
            robotsMeta.name = 'robots';
            robotsMeta.content = 'notranslate';
            document.head.appendChild(robotsMeta);
        }

        return () => {
            // Очистка при размонтировании (опционально)
        };
    }, []);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (usr) => {
            if (usr) {
                setUser(usr);
                const userDocRef = doc(firestore, 'users', usr.uid);
                const userDocSnap = await getDoc(userDocRef);
                if (userDocSnap.exists()) {
                    setUserInfo(userDocSnap.data());
                }
            }
        });
        return () => {
            unsubscribe();
        };
    }, [firestore]);

    useEffect(() => {
        if (user) {
            const chatsRef = ref(realtimeDb, 'chats');
            onValue(chatsRef, (snapshot) => {
                const allChats = [];
                snapshot.forEach((snap) => {
                    const chatData = { id: snap.key, ...snap.val() };
                    if (chatData.creatorId === user.uid) {
                        allChats.push(chatData);
                    }
                });

                const promises = allChats.map(async (c) => {
                    const messagesRef = ref(realtimeDb, `chats/${c.id}/messages`);
                    const msgs = await new Promise((resolve) => {
                        onValue(messagesRef, (snap) => {
                            const arr = [];
                            snap.forEach((child) => {
                                arr.push({ id: child.key, ...child.val() });
                            });
                            resolve(arr);
                        });
                    });

                    c.messages = msgs;
                    c.unreadCount = countUnreadMessagesInChat(msgs);
                    return c;
                });

                Promise.all(promises).then((results) => {
                    const unreadObj = {};
                    results.forEach((r) => {
                        unreadObj[r.id] = r.unreadCount;
                    });
                    setUnreadCounts(unreadObj);

                    const sorted = results.sort((a, b) => {
                        if (b.unreadCount !== a.unreadCount) {
                            return b.unreadCount - a.unreadCount;
                        }
                        const bTime = new Date(b.lastMessage?.timestamp || 0).getTime();
                        const aTime = new Date(a.lastMessage?.timestamp || 0).getTime();
                        return bTime - aTime;
                    });

                    setChats(sorted);
                });
            });
        }
    }, [user]);

    const countUnreadMessagesInChat = (msgs) => {
        if (!user) return 0;
        return msgs.reduce((count, m) => {
            if (!m.isRead && m.senderId !== user.uid) {
                return count + 1;
            }
            return count;
        }, 0);
    };

useEffect(() => {
    let messagesRef;
    if (selectedChat) {
        messagesRef = ref(realtimeDb, `chats/${selectedChat.id}/messages`);
        onValue(messagesRef, (snap) => {
            const msgsArr = [];
            snap.forEach((child) => {
                msgsArr.push({ id: child.key, ...child.val() });
            });
            setMessages(msgsArr);

            // Отмечаем сообщения как прочитанные
            msgsArr.forEach((m) => {
                if (!m.isRead && m.senderId !== user?.uid) {
                    set(ref(realtimeDb, `chats/${selectedChat.id}/messages/${m.id}/isRead`), true);
                    set(ref(realtimeDb, `chats/${selectedChat.id}/messages/${m.id}/readAt`), new Date().toISOString());
                }
            });
            
            // Прокручиваем с задержкой для рендеринга
            setTimeout(() => {
                forceScrollToBottom();
            }, 200);
        });
    }

    return () => {
        if (messagesRef) off(messagesRef);
    };
}, [selectedChat, user]);

useEffect(() => {
    if (messages.length > 0) {
        // Используем более агрессивную прокрутку при добавлении новых сообщений
        setTimeout(() => {
            forceScrollToBottom();
        }, 100);
        
        // Дополнительная прокрутка для мобильных устройств
        if (window.innerWidth <= 768) {
            setTimeout(() => {
                forceScrollToBottom();
            }, 400);
        }
    }
}, [messages]);
// Замените существующую функцию scrollToBottom на эту:

// Улучшенные функции прокрутки:

const scrollToBottom = () => {
    if (messagesEndRef.current) {
        const messagesContainer = messagesEndRef.current.closest('.messages');
        if (messagesContainer) {
            // Для мобильных устройств
            if (window.innerWidth <= 768) {
                const isKeyboardOpen = document.body.classList.contains('keyboard-open');
                
                setTimeout(() => {
                    // Прокручиваем к самому низу контейнера
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                    
                    // Дополнительная прокрутка для компенсации возможных задержек рендеринга
                    setTimeout(() => {
                        messagesContainer.scrollTop = messagesContainer.scrollHeight;
                    }, isKeyboardOpen ? 200 : 100);
                }, 100);
            } else {
                // Для десктопа
                setTimeout(() => {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                }, 100);
            }
        }
    }
};

const scrollToBottomAfterSend = () => {
    setTimeout(() => {
        if (messagesEndRef.current) {
            const messagesContainer = messagesEndRef.current.closest('.messages');
            if (messagesContainer) {
                // Принудительная прокрутка к самому низу
                messagesContainer.scrollTop = messagesContainer.scrollHeight;
                
                // Дополнительная прокрутка через короткое время для iOS
                if (window.innerWidth <= 768) {
                    setTimeout(() => {
                        messagesContainer.scrollTop = messagesContainer.scrollHeight;
                    }, 150);
                    
                    // Еще одна прокрутка для надежности на iOS
                    setTimeout(() => {
                        messagesContainer.scrollTop = messagesContainer.scrollHeight;
                    }, 300);
                }
            }
        }
    }, 50);
};

// Добавьте новую функцию для принудительной прокрутки
const forceScrollToBottom = () => {
    if (messagesEndRef.current) {
        const messagesContainer = messagesEndRef.current.closest('.messages');
        if (messagesContainer) {
            // Убираем smooth scroll временно для принудительной прокрутки
            messagesContainer.style.scrollBehavior = 'auto';
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
            
            // Возвращаем smooth scroll
            setTimeout(() => {
                messagesContainer.style.scrollBehavior = 'smooth';
            }, 100);
        }
    }
};
useEffect(() => {
    // Устанавливаем атрибуты для предотвращения перевода при монтировании компонента
    document.documentElement.setAttribute('translate', 'no');
    document.documentElement.setAttribute('lang', 'pl');
    document.documentElement.classList.add('notranslate');
    
    if (!document.querySelector('meta[name="google"][content="notranslate"]')) {
        const googleMeta = document.createElement('meta');
        googleMeta.name = 'google';
        googleMeta.content = 'notranslate';
        document.head.appendChild(googleMeta);
    }
    
    if (!document.querySelector('meta[name="robots"][content="notranslate"]')) {
        const robotsMeta = document.createElement('meta');
        robotsMeta.name = 'robots';
        robotsMeta.content = 'notranslate';
        document.head.appendChild(robotsMeta);
    }

    // НОВЫЙ КОД: Фикс для правильной работы viewport на iOS
    const setVH = () => {
        // Получаем реальную высоту viewport (без учета адресной строки и панели инструментов)
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        
        // Устанавливаем CSS-переменные для safe area (iOS)
        if (window.CSS && window.CSS.supports && window.CSS.supports('padding', 'env(safe-area-inset-top)')) {
            document.documentElement.style.setProperty('--safe-area-inset-top', 'env(safe-area-inset-top)');
            document.documentElement.style.setProperty('--safe-area-inset-bottom', 'env(safe-area-inset-bottom)');
        } else {
            document.documentElement.style.setProperty('--safe-area-inset-top', '0px');
            document.documentElement.style.setProperty('--safe-area-inset-bottom', '0px');
        }
    };

    // Вызываем при загрузке
    setVH();

    // Обновляем при изменении размера окна (когда появляется/скрывается адресная строка)
    const handleResize = () => {
        // Добавляем небольшую задержку для стабилизации на iOS
        setTimeout(setVH, 100);
    };

    // Обновляем при изменении ориентации
    const handleOrientationChange = () => {
        // Больше задержки для ориентации, так как iOS требует времени для обновления viewport
        setTimeout(setVH, 300);
    };

    // Фикс для правильной работы фиксированных элементов на iOS
    const preventOverscroll = (e) => {
        // Предотвращаем overscroll который может сломать фиксированное позиционирование
        const target = e.target;
        const messagesContainer = target.closest('.messages');
        
        if (messagesContainer) {
            const { scrollTop, scrollHeight, clientHeight } = messagesContainer;
            
            // Если прокручиваем вверх и уже в самом верху
            if (e.deltaY < 0 && scrollTop === 0) {
                e.preventDefault();
            }
            
            // Если прокручиваем вниз и уже в самом низу
            if (e.deltaY > 0 && scrollTop + clientHeight >= scrollHeight) {
                e.preventDefault();
            }
        }
    };

    // Добавляем обработчики событий
    window.addEventListener('resize', handleResize, { passive: true });
    window.addEventListener('orientationchange', handleOrientationChange, { passive: true });
    window.addEventListener('wheel', preventOverscroll, { passive: false });
    
    // Также слушаем событие визуального viewport для более точной работы на iOS
    if (window.visualViewport) {
        const handleVisualViewportChange = () => {
            const vh = window.visualViewport.height * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        
        window.visualViewport.addEventListener('resize', handleVisualViewportChange, { passive: true });
        
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleOrientationChange);
            window.removeEventListener('wheel', preventOverscroll);
            window.visualViewport?.removeEventListener('resize', handleVisualViewportChange);
        };
    }

    return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleOrientationChange);
        window.removeEventListener('wheel', preventOverscroll);
    };
}, []);
    const createChat = async () => {
        if (!chatName.trim() || !newChatFirstMessage.trim()) return;

        const newChatRef = push(ref(realtimeDb, 'chats'));
        const newChatKey = newChatRef.key;
        const now = new Date().toISOString();
        const creatorName = `${userInfo.firstName || ''} ${userInfo.lastName || ''}`.trim() || user.email;

        await set(newChatRef, {
            chatName,
            creatorId: user.uid,
            creatorName,
            timestamp: now,
            status: 'open',
            lastMessage: {
                text: '',
                senderName: '',
                timestamp: '',
                senderRole: 'user',
            },
            admins: [],
        });

        const firstMsgData = {
            text: newChatFirstMessage,
            fileUrl: null,
            fileType: null,
            sender: creatorName,
            senderId: user.uid,
            senderRole: 'user',
            timestamp: now,
            isRead: false,
            readAt: null,
        };

        await push(ref(realtimeDb, `chats/${newChatKey}/messages`), firstMsgData);
        await set(ref(realtimeDb, `chats/${newChatKey}/lastMessage`), {
            text: newChatFirstMessage,
            fileUrl: null,
            fileType: null,
            senderName: creatorName,
            senderRole: 'user',
            timestamp: now,
            isRead: false,
        });

        setChatName('');
        setNewChatFirstMessage('');
        setIsCreateChatModalVisible(false);

        setSelectedChat({
            id: newChatKey,
            chatName,
            status: 'open',
            creatorId: user.uid,
            admins: [],
        });
        setIsModalVisible(true);
    };

    const openChat = (chat) => {
        setSelectedChat(chat);
        setIsModalVisible(true);
    };

// Обновите функцию sendMessage:

const sendMessage = async () => {
    if ((!message.trim() && !selectedFile) || !selectedChat) return;

    let fileUrl = null;
    let fileType = null;

    if (selectedFile) {
        const filePath = `chatFiles/${selectedChat.id}/${Date.now()}_${selectedFile.name}`;
        const fileRef = storageRef(storage, filePath);
        await uploadBytes(fileRef, selectedFile);
        fileUrl = await getDownloadURL(fileRef);
        fileType = selectedFile.type;
    }

    const senderDocRef = doc(firestore, 'users', user.uid);
    const senderDocSnap = await getDoc(senderDocRef);
    const senderName = senderDocSnap.exists()
        ? `${senderDocSnap.data().firstName} ${senderDocSnap.data().lastName}`
        : user.email;

    const now = new Date().toISOString();
    const msgData = {
        text: message,
        fileUrl: fileUrl || null,
        fileType: fileType || null,
        sender: senderName,
        senderId: user.uid,
        senderRole: 'user',
        timestamp: now,
        isRead: false,
        readAt: null,
    };

    await push(ref(realtimeDb, `chats/${selectedChat.id}/messages`), msgData);
    await set(ref(realtimeDb, `chats/${selectedChat.id}/lastMessage`), {
        text: message,
        fileUrl: fileUrl || null,
        fileType: fileType || null,
        senderName,
        senderRole: 'user',
        timestamp: now,
        isRead: false,
    });

    // Очищаем поля ввода
    setMessage('');
    setSelectedFile(null);
    setPreviewImageUrl(null);
    
    // Убираем фокус с input для iOS (закрывает клавиатуру если нужно)
    if (window.innerWidth <= 768) {
        const activeElement = document.activeElement;
        if (activeElement && activeElement.tagName === 'INPUT') {
            activeElement.blur();
            
            // Небольшая задержка перед прокруткой
            setTimeout(() => {
                scrollToBottomAfterSend();
            }, 100);
        }
    } else {
        scrollToBottom();
    }
};

    const handleFileChange = (info) => {
        const file = info.file.originFileObj || info.file;
        if (file instanceof Blob) {
            setSelectedFile(file);
            if (file.type.startsWith('image/')) {
                const previewUrl = URL.createObjectURL(file);
                setPreviewImageUrl(previewUrl);
            } else {
                setPreviewImageUrl(null);
            }
        } else {
            console.error('The selected file is not a valid Blob or File object');
        }
    };

    const removeSelectedImage = () => {
        setSelectedFile(null);
        setPreviewImageUrl(null);
    };

    const openImageModal = (imageUrl) => {
        setModalImageUrl(imageUrl);
        setIsImageModalVisible(true);
    };

    const closeImageModal = () => {
        setModalImageUrl(null);
        setIsImageModalVisible(false);
    };

    const extractFileName = (url) => {
        try {
            const fullPath = decodeURIComponent(url.split('?')[0]);
            return fullPath.substring(fullPath.lastIndexOf('/') + 1);
        } catch (error) {
            return 'File';
        }
    };

    const truncateFileName = (fileName, maxLength = 20) => {
        if (fileName.length <= maxLength) return fileName;
        const extIndex = fileName.lastIndexOf('.');
        const extension = extIndex > -1 ? fileName.slice(extIndex) : '';
        const baseName = extIndex > -1 ? fileName.slice(0, extIndex) : fileName;
        return `${baseName.slice(0, maxLength - extension.length - 3)}...${extension}`;
    };

// Обновленная функция formatMessages с дополнительным спейсером:

const formatMessages = () => {
    const formatted = [];
    let lastDate = '';

    messages.forEach((msg) => {
        const messageDate = new Intl.DateTimeFormat('pl-PL', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(new Date(msg.timestamp));

        if (messageDate !== lastDate) {
            formatted.push(
                <div key={`sep-${messageDate}`} className="date-separator" translate="no">
                    {messageDate}
                </div>
            );
            lastDate = messageDate;
        }

        const isOwn = msg.senderId === user?.uid;
        const bubbleClass = isOwn ? 'you' : 'other';

        formatted.push(
            <div key={msg.id || msg.timestamp} className={`message-item ${bubbleClass}`} translate="no">
                <div className="message-bubble">
                    <div className="message-meta">
                        <span className="message-name" translate="no">{isOwn ? 'Ty' : msg.sender}</span>
                        <span className="message-time" translate="no">
                            {new Intl.DateTimeFormat('pl-PL', {
                                hour: 'numeric',
                                minute: 'numeric',
                            }).format(new Date(msg.timestamp))}
                        </span>
                    </div>

                    {msg.text && <div translate="no">{msg.text}</div>}
                    {msg.fileUrl && msg.fileType?.startsWith('image/') && (
                        <img
                            src={msg.fileUrl}
                            alt="Zdjęcie"
                            style={{ maxWidth: '100%', cursor: 'pointer', marginTop: '0.5rem' }}
                            onClick={() => openImageModal(msg.fileUrl)}
                            translate="no"
                        />
                    )}
                    {msg.fileUrl && msg.fileType && !msg.fileType.startsWith('image/') && (
                        <div style={{ marginTop: '0.5rem' }} translate="no">
                            <FileOutlined style={{ fontSize: '24px', marginRight: '8px' }} />
                            <a href={msg.fileUrl} download>
                                {truncateFileName(extractFileName(msg.fileUrl))}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        );
    });

    // Добавляем дополнительный спейсер для последнего сообщения
    formatted.push(
        <div 
            key="bottom-spacer" 
            style={{ 
                height: window.innerWidth <= 768 ? '40px' : '20px',
                width: '100%',
                flexShrink: 0
            }} 
        />
    );

    // Элемент для прокрутки
    formatted.push(<div key="end" ref={messagesEndRef} />);
    
    return formatted;
};

    // Улучшенная функция renderChatHeader с кнопкой закрытия
// Улучшенная функция renderChatHeader с кнопкой закрытия
const renderChatHeader = () => {
    if (!selectedChat) return null;

    const admin = selectedChat.admins && selectedChat.admins.length > 0 ? selectedChat.admins[0] : null;
    
    // Функция для сокращения названия чата
    const truncateChatName = (name, maxLength = 30) => {
        if (name.length <= maxLength) return name;
        return `${name.substring(0, maxLength)}...`;
    };

    // Функция для получения статуса текста
    const getStatusText = () => {
        if (admin) {
            return `Rozmowa z: ${admin.firstName} ${admin.lastName}`;
        } else {
            // Изменяем текст в зависимости от статуса чата
            if (selectedChat.status === 'open') {
                return (
                    <span>
                        Szukamy rozwiązanie
                        <span className="loading-dots">
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                        </span>
                    </span>
                );
            } else if (selectedChat.status === 'closed') {
                return 'Problem rozwiązany';
            } else {
                return 'Oczekiwanie na dołączenie obsługi';
            }
        }
    };

    return (
        <div translate="no" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                <h2 style={{ 
                    margin: '0 0 8px 0', 
                    fontSize: '1.2rem', 
                    fontWeight: '600',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%'
                }}>
                    {truncateChatName(selectedChat.chatName)}
                </h2>
                <div style={{ 
                    color: 'rgba(255, 255, 255, 0.9)', 
                    fontSize: '14px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>
                    <div>{getStatusText()}</div>
                </div>
            </div>
            <Button 
                type="text" 
                icon={<CloseOutlined />} 
                onClick={() => setIsModalVisible(false)}
                className="chat-close-button"
                style={{
                    color: '#fff',
                    border: 'none',
                    background: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    minWidth: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '18px',
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease',
                    flexShrink: 0,
                    marginLeft: '1rem'
                }}
            />
        </div>
    );
};

    return (
        <div className="chat-container" translate="no">
            <div className="chat-list">
                <div className="chat-header">
                    <h2 translate="no">Pomoc</h2>
                    <Button type="primary" onClick={() => setIsCreateChatModalVisible(true)}>
                        <span translate="no">Utwórz nowe zgłoszenie</span>
                    </Button>
                </div>
                <Divider orientation="left" plain>
                    <span translate="no">Ostatnie rozmowy</span>
                </Divider>
                <List
                    itemLayout="horizontal"
                    dataSource={chats}
                    renderItem={(chat) => {
                        const isUnread = unreadCounts[chat.id] > 0;
                        const textStyle = { fontWeight: isUnread ? 'bold' : 'normal' };

                        return (
                            <List.Item onClick={() => openChat(chat)} translate="no">
                                <List.Item.Meta
                                    title={
                                        <div className="chat-title-row">
                                            <div className="chat-title-wrapper">
                                                <Badge
                                                    count={unreadCounts[chat.id] || 0}
                                                    overflowCount={99}
                                                    offset={[8, 0]}
                                                    size="small"
                                                >
                                                    <span style={textStyle} translate="no" className="chat-name-text">
                                                        {chat.chatName}
                                                    </span>
                                                </Badge>
                                            </div>
                                            <span className={`chat-status-inline ${chat.status.toLowerCase()}`}>
                                                {chat.status === 'open' ? 'Otwarte' : 'Zamknięte'}
                                            </span>
                                        </div>
                                    }
                                    description={
                                        <div translate="no">
                                            <div className="chat-simple-layout">
                                                {/* Divider */}
                                                <div className="chat-simple-divider"></div>
                                                
                                                {/* Ostatnia wiadomość */}
                                                <div className="chat-last-message">
                                                    {chat.lastMessage && chat.lastMessage.text ? (
                                                        <span className="last-message-text">
                                                            {chat.lastMessage.text.length > 60 
                                                                ? `${chat.lastMessage.text.substring(0, 60)}...` 
                                                                : chat.lastMessage.text
                                                            }
                                                        </span>
                                                    ) : (
                                                        <span className="no-message-text">Brak wiadomości</span>
                                                    )}
                                                    <span className="last-message-time">
                                                        {chat.lastMessage && chat.lastMessage.timestamp 
                                                            ? new Date(chat.lastMessage.timestamp).toLocaleDateString('pl-PL')
                                                            : new Date(chat.timestamp).toLocaleDateString('pl-PL')
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                />
                            </List.Item>
                        );
                    }}
                />
            </div>

            <Modal
                title={<span translate="no">Utwórz nowy czat</span>}
                visible={isCreateChatModalVisible}
                onCancel={() => setIsCreateChatModalVisible(false)}
                onOk={createChat}
                okText={<span translate="no">Utwórz</span>}
                cancelText={<span translate="no">Anuluj</span>}
            >
                <Input
                    placeholder="Nazwa nowego czatu (temat)"
                    value={chatName}
                    onChange={(e) => setChatName(e.target.value)}
                    style={{ marginBottom: '1rem' }}
                    translate="no"
                />
                <Input.TextArea
                    placeholder="Pierwsza wiadomość"
                    value={newChatFirstMessage}
                    onChange={(e) => setNewChatFirstMessage(e.target.value)}
                    rows={4}
                    translate="no"
                />
            </Modal>

            <Modal
                title={renderChatHeader()}
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                style={{ top: 20 }}
                bodyStyle={{ padding: 0 }}
                width="100%"
                className="chat-modal"
                closable={false}
            >
                {selectedChat ? (
                    <div className="chat-window" translate="no">
                        <div className="messages">{formatMessages()}</div>
                        {selectedChat.status === 'open' ? (
                            <>
                                {previewImageUrl ? (
                                    <div className="image-preview">
                                        <img
                                            src={previewImageUrl}
                                            alt="Preview"
                                            onClick={removeSelectedImage}
                                            style={{ cursor: 'pointer' }}
                                        />
                                        <CloseCircleOutlined
                                            onClick={removeSelectedImage}
                                            style={{ position: 'absolute', top: 8, right: 8 }}
                                        />
                                    </div>
                                ) : selectedFile ? (
                                    <div className="file-preview">
                                        <FileOutlined style={{ fontSize: '48px' }} />
                                        <span translate="no">{selectedFile.name}</span>
                                        <CloseCircleOutlined
                                            onClick={removeSelectedImage}
                                            style={{ position: 'absolute', top: 8, right: 8 }}
                                        />
                                    </div>
                                ) : null}

                                <div className="message-input">
                                    <Input
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        onPressEnter={sendMessage}
                                        placeholder="Napisz wiadomość..."
                                        translate="no"
                                    />

                                    <div className="toolbox-icons">
                                        <Upload
                                            beforeUpload={() => false}
                                            onChange={handleFileChange}
                                            showUploadList={false}
                                        >
                                            <Button icon={<UploadOutlined />} />
                                        </Upload>
                                    </div>
                                    <div className="toolbox-icons">
                                        <Button icon={<SendOutlined />} onClick={sendMessage} />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="chat-closed-message" style={{ padding: '1rem' }} translate="no">
                                <p>Czat zamknięty przez administratora.</p>
                                <p>Żeby napisać wiadomość, utwórz nowe zgłoszenie.</p>
                                <Button type="primary" onClick={() => setIsCreateChatModalVisible(true)}>
                                    <span translate="no">Utwórz nowy czat</span>
                                </Button>
                            </div>
                        )}
                    </div>
                ) : (
                    <div style={{ padding: '1rem' }} translate="no">Proszę wybrać czat</div>
                )}
            </Modal>

            <Modal
                visible={isImageModalVisible}
                footer={null}
                onCancel={closeImageModal}
                style={{ top: 20 }}
            >
                <img src={modalImageUrl} alt="Modal Content" style={{ width: '100%' }} />
                <Button type="primary" href={modalImageUrl} download style={{ marginTop: '10px' }}>
                    <span translate="no">Pobierz</span>
                </Button>
            </Modal>
        </div>
    );
};

export default Pomoc;